import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "radio"]

  connect() {
    // Set up radio change listeners
    this.radioTargets.forEach(radio => {
      radio.addEventListener("change", () => this.previewLocale(radio.value))
    })
  }

  previewLocale(locale) {
    // Store the current form action
    const originalAction = this.formTarget.action
    
    // Add preview=true parameter to the URL
    const previewUrl = new URL(originalAction)
    previewUrl.searchParams.set('preview', 'true')
    
    // Create a temporary form and submit it to preview the locale
    const tempForm = document.createElement('form')
    tempForm.style.display = 'none'
    tempForm.method = 'POST'
    tempForm.action = previewUrl.toString()
    
    // Add authenticity token
    const authenticityToken = document.querySelector('meta[name="csrf-token"]').content
    const tokenInput = document.createElement('input')
    tokenInput.type = 'hidden'
    tokenInput.name = 'authenticity_token'
    tokenInput.value = authenticityToken
    tempForm.appendChild(tokenInput)
    
    // Add locale parameter
    const localeInput = document.createElement('input')
    localeInput.type = 'hidden'
    localeInput.name = 'user[locale]'
    localeInput.value = locale
    tempForm.appendChild(localeInput)
    
    // Add _method parameter for PATCH request
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'patch'
    tempForm.appendChild(methodInput)
    
    // Submit the form
    document.body.appendChild(tempForm)
    tempForm.submit()
  }
}
